<!-- tree-list.component.html -->

<div style="margin-top: 3%">
  <div (click)="toggle()" class="node">
    <span *ngIf="treeData?.id.includes('F')" class="toggle-icon">
      <ion-icon
        style="margin-right: 5px; width: 20px; height: 20px !important"
        *ngIf="!isOpen || treeData?.id.includes('F')"
        slot="start"
        src="./assets/icon/windowsFolder.svg"
      ></ion-icon>
    </span>
    <ion-label class="ionLabel">{{ treeData?.text }}</ion-label>
  </div>
  <div *ngIf="isOpen && treeData?.children" class="children">
    <app-tree-list
      *ngFor="let child of treeData?.children"
      [treeData]="child"
    ></app-tree-list>
  </div>
</div>
